import React from 'react'
import { Link } from 'react-router-dom'
import Games from '../components/Games'
import LotteryGames from '../components/LotteryGames'
import Wins from '../components/Wins'
import bg from '../Assets/background.png'
import vol from '../Assets/vol.png'
import det from '../Assets/det.png'

const Home = () => {
  return (
    <div className='w-full p-2 flex flex-col justify-center items-center'>
      <img className='mb-4' src={bg} alt='bg'/>
      <div class="scrolling-container m-3 my-2 flex justify-center items-center bg-white">
        <div className='p-2'>
          <img className='w-[20px]' src={vol} alt='vol'/>
        </div>
          <marquee behavior="scroll" direction="left" scrollamount="4">
              <p className='text-sm text-orange-600'>OFFICIAL Emirates Club WEBSITE LINK: emiratesclub.com please make sure, to always use this links to login , dont use other link to login to avoid any fraud, All recharge methods only available in RECHARGE menu on OFFICIAL TC website and application; 2.Submit 12 UTR number / UPI ref no for INSTANT recharge; 3. TC recharge account change everytime, DONOT SAVE to AVOID LOSS!!!</p>
          </marquee>
          <div className='bg-white p-2'>

          <div className='flex justify-center items-center cursor-pointer px-4 py-[0.15rem] bg-orange-500 rounded-full'>
              <img className='w-[12px] h-[12px]' src={det} alt='det'/>
              <p className='text-[0.8rem] text-white'>Detail</p>
        </div>
        </div>
      </div>
        <Games/>
        <LotteryGames/>
    </div>
  )
}

export default Home